var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "ok": _vm.emitConfirmed
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t('customer.delete.confirm.short')) + " ")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('customer.delete.confirm', _vm.customer))
          }
        }), _c('div', {
          staticClass: "mt-2 text-center text-danger"
        }, [_c('b-checkbox', {
          model: {
            value: _vm.confirm,
            callback: function callback($$v) {
              _vm.confirm = $$v;
            },
            expression: "confirm"
          }
        }, [_vm._v(_vm._s(_vm.$t('customer.delete.confirm.check')))])], 1)];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
            cancel = _ref.cancel,
            hide = _ref.hide;
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v(_vm._s(_vm.$t('controls.abort')))]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": !_vm.confirm
          },
          on: {
            "click": ok
          }
        }, [_vm._v(_vm._s(_vm.$t('controls.delete')))])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }